module.exports = __webpack_public_path__ + "static/media/info.e85c05bb.svg";